import React, { useState, useEffect } from 'react';
import { Button } from './ui/button';
import { Menu, X, Phone } from 'lucide-react';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header data-testid="main-header" className={`header ${isScrolled ? 'scrolled' : ''}`}>
      <div className="container">
        <div className="header-content">
          <div className="header-logo" data-testid="header-logo" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
            <img 
              src="https://customer-assets.emergentagent.com/job_portfolio-pro-505/artifacts/6rf6onic_885ea933-b00e-4489-80dc-ff243e4d3458-removebg-preview.png" 
              alt="Green Art Logo" 
              className="logo-image"
            />
          </div>

          <nav className={`header-nav ${isMobileMenuOpen ? 'mobile-open' : ''}`}>
            <button onClick={() => scrollToSection('hero')} className="nav-link">Home</button>
            <button onClick={() => scrollToSection('about-section')} className="nav-link">About</button>
            <button onClick={() => scrollToSection('services')} className="nav-link">Services</button>
            <button onClick={() => scrollToSection('projects-section')} className="nav-link">Projects</button>
            <button onClick={() => scrollToSection('partners-section')} className="nav-link">Partners</button>
            <button onClick={() => scrollToSection('certifications')} className="nav-link">Certifications</button>
            
            <Button 
              onClick={() => scrollToSection('quote-section')}
              variant="outline"
              className="btn-contact btn-3d"
              data-testid="header-contact-btn"
            >
              <Phone className="w-4 h-4 contact-phone-icon" />
              <span>Contact Us</span>
            </Button>

            <Button 
              onClick={() => scrollToSection('quote-section')}
              className="btn-primary btn-3d"
              data-testid="header-get-quote-btn"
            >
              Get Quote
            </Button>
          </nav>

          <button 
            className="mobile-menu-toggle"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="Toggle menu"
          >
            {isMobileMenuOpen ? <X /> : <Menu />}
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
